(function () {
  'use strict';

  function initJvReveal(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll('.jv-reveal:not(.is-visible)');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initJvNav() {
    var burger = document.querySelector('.jv-burger');
    var nav = document.querySelector('.jv-nav');
    if (!burger || !nav) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      document.body.classList.toggle('jvmenu-open', open);
      if (open) {
        var first = nav.querySelector('a');
        if (first) window.setTimeout(function () { first.focus(); }, 40);
      }
    }

    burger.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        burger.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 850 && nav.classList.contains('is-open')) setOpen(false);
    });
  }

  function normalized(value) {
    return (value || '').toLocaleLowerCase('fr-FR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function filterCatalogue(query) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.jv-grid .jv-card'));
    if (!cards.length) return false;
    var q = normalized(query);
    var visible = 0;
    cards.forEach(function (card) {
      var haystack = normalized(card.textContent + ' ' + (card.getAttribute('href') || ''));
      var match = !q || haystack.indexOf(q) !== -1;
      card.hidden = !match;
      if (match) visible += 1;
    });

    var counter = document.querySelector('.jv-shop-intro__count');
    if (counter) counter.textContent = visible + (visible > 1 ? ' produits' : ' produit') + (q ? ' correspondant à votre recherche' : ' sélectionnés avec soin');

    var grid = document.querySelector('.jv-grid');
    var oldEmpty = grid && grid.querySelector('.jv-search-empty');
    if (oldEmpty) oldEmpty.remove();
    if (grid && q && visible === 0) {
      var empty = document.createElement('div');
      empty.className = 'jv-search-empty';
      empty.innerHTML = '<strong>Aucun produit trouvé.</strong><br>Essayez un terme plus général.';
      grid.appendChild(empty);
    }
    return true;
  }

  function initJvSearch() {
    var forms = document.querySelectorAll('.jv-search');
    if (!forms.length) return;
    var params = new URLSearchParams(window.location.search);
    var initial = params.get('q') || '';
    // La recherche passe toujours par Shopify (/search) : plus de filtre local qui masquait des résultats.
    var isCatalogue = false;

    if (initial && isCatalogue) filterCatalogue(initial);
    forms.forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      if (input && initial) input.value = initial;
      form.addEventListener('submit', function (e) {
        if (!isCatalogue) return; // no local grid to filter: let the form submit natively to routes.search_url
        e.preventDefault();
        var q = input ? input.value.trim() : '';
        filterCatalogue(q);
        var url = new URL(window.location.href);
        if (q) url.searchParams.set('q', q); else url.searchParams.delete('q');
        history.replaceState({}, '', url.pathname + url.search);
      });
    });
  }

  function initPlaceholderLinks() {
    document.querySelectorAll('[data-jv-placeholder="true"]').forEach(function (link) {
      link.addEventListener('click', function (e) { e.preventDefault(); });
    });
  }

  // Promesse d'expédition : heure de Bruxelles, lundi-vendredi (jours fériés non gérés).
  function initJvShip() {
    var el = document.querySelector('[data-jv-ship]');
    if (!el || !window.Intl) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 12;
    var days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
    function render() {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      var day = days[parts.weekday], mins = parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10);
      var left = cutoff * 60 - mins;
      if (day <= 5 && left > 0) {
        var h = Math.floor(left / 60), m = left % 60;
        el.textContent = 'Commandez avant ' + cutoff + ' h, expédié aujourd’hui (encore ' + (h ? h + ' h ' : '') + (h ? ('0' + m).slice(-2) : m + ' min') + ')';
      } else if (day <= 4) {
        el.textContent = 'Commandé maintenant, expédié demain';
      } else {
        el.textContent = 'Commandé maintenant, expédié lundi';
      }
    }
    render();
    window.setInterval(render, 60000);
  }

  // Bandeau d'annonce : un message toutes les 6 s, pause au survol, au focus et onglet masqué ;
  // rien ne bouge si « mouvement réduit » est demandé (spéc. GPT du 11/10/2026).
  function initJvAnnounce() {
    var bar = document.querySelector('[data-jv-announce]');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.jv-announce__msg');
    if (msgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, paused = false;
    function show(next) {
      var cur = msgs[i];
      cur.classList.add('is-leaving');
      cur.classList.remove('is-current');
      cur.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () { cur.classList.remove('is-leaving'); }, 260);
      i = next;
      msgs[i].classList.add('is-current');
      msgs[i].removeAttribute('aria-hidden');
    }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    window.setInterval(function () {
      if (paused || document.hidden) return;
      show((i + 1) % msgs.length);
    }, 6000);
  }

  // Cartes d'une même grille : léger décalage d'apparition (50 ms, plafonné à 150 ms)
  function staggerCards() {
    document.querySelectorAll('.jv-card.jv-reveal').forEach(function (card) {
      var siblings = card.parentElement ? card.parentElement.children : [];
      var idx = Array.prototype.indexOf.call(siblings, card) % 4;
      card.style.transitionDelay = Math.min(idx * 50, 150) + 'ms';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initJvShip();
    initJvAnnounce();
    staggerCards();
    initJvReveal(document);
    initJvNav();
    initJvSearch();
    initPlaceholderLinks();
  });
})();
